import { Lang } from '../SubmissionV2/translations'

const TH = {
  common: {
    saveAndExit: 'บันทึกและออก',
    chatWithUs: 'Chat with us',
    back: '← ย้อนกลับ',
    next: 'ถัดไป',
    confirm: 'ยืนยัน',
    save: 'บันทึก',
    saving: 'กำลังบันทึก...',
    loading: 'กำลังโหลด...',
    uploading: 'กำลังอัปโหลด...',
    uploadOrTakePhoto: 'อัปโหลดหรือถ่ายรูป',
    edit: 'แก้ไข',
    delete: 'ลบ',
    cancel: 'ยกเลิก',
    yes: 'ใช่',
    no: 'ไม่ใช่',
    carType: 'ประเภทรถ',
    selectCarType: 'เลือกประเภทรถ',
    stepOf: (current: number, total: number) => `ขั้นตอนที่ ${current} จาก ${total}`,
    charCount: (count: number, max: number) => `${count}/${max} ตัวอักษร`,
    hours: (n: number) => `${n} ชั่วโมง`,
    netRevenueTitle: 'รายได้สุทธิ (Net Revenue)',
    netRevenueDesc:
      'รายได้สุทธิคือจำนวนเงินสุดท้ายที่คุณจะได้รับ โดยจะถูกหักภาษี ณ ที่จ่าย 3% เท่านั้น ไม่มีค่าธรรมเนียมอื่นเพิ่มเติม',
    netRevenueNote:
      'ราคาที่คุณกำหนดที่นี่คือรายได้สุทธิหลังหักค่าบริการ ซึ่งอาจแตกต่างจากราคาที่แสดงให้ผู้เช่าเห็นในแอป HAUP',
    deleteItemTitle: 'ลบรายการนี้?',
    deleteItemDesc: 'คุณต้องการลบรายการนี้ใช่หรือไม่? การดำเนินการนี้ไม่สามารถย้อนกลับได้',
    successTitle: 'สำเร็จ! รถของคุณลงประกาศบนแพลตฟอร์มแล้ว',
    connectLineTitle: 'เชื่อมต่อกับเราบน LINE',
    connectLineDesc:
      'ก่อนดำเนินการขั้นตอนถัดไป กรุณาเชื่อมต่อกับเราบน LINE ทีมงานจะช่วยแนะนำและติดตามคำขอของคุณโดยตรง',
    remainingSteps: 'ขั้นตอนที่เหลือเพื่อเสร็จสิ้น',
    applicationSubmitted: 'ส่งใบสมัครแล้ว',
    carListed: 'รถของคุณลงประกาศบนแพลตฟอร์มแล้ว',
    uploadRequiredDocs: 'อัปโหลดเอกสารที่จำเป็น',
    uploadRequiredDocsDesc: 'อัปโหลดเอกสารให้ครบก่อนรับการจองที่เข้ามา',
    downloadApp: 'ดาวน์โหลดแอป',
    downloadAppDesc: 'คุณต้องดาวน์โหลดแอปเพื่อจัดการรายการรถ รับคำขอ และติดตามรายได้',
    notDone: 'ยังไม่เสร็จ',
    manageYourCars: 'จัดการรถของคุณ',
    skipAndSubmit: 'ข้ามและส่ง',
    submitting: 'กำลังส่ง...',
  },
  page: {
    step: (n: number) => `ขั้นตอนที่ ${n}`,
    loadingDraft: 'กำลังโหลดข้อมูล...',
    tutorials: {
      1: {
        title: 'เพิ่มสถานที่รถของคุณ',
        description:
          'คุณจะถูกขอให้ระบุสถานที่ที่บริการของคุณให้บริการ เช่น สนามบิน โรงแรม หรือจุดหมายที่เป็นที่นิยม สถานที่ที่ชัดเจนและถูกต้องช่วยให้ผู้เช่าจองด้วยความมั่นใจและมั่นใจได้ว่าบริการจะเป็นไปอย่างราบรื่นและตรงเวลา',
      },
      2: {
        title: 'บอกเล่าเกี่ยวกับรถของคุณ',
        description:
          'คุณจะถูกขอให้เพิ่มรายละเอียดรถ เช่น ยี่ห้อ รุ่น ประเภท และรูปภาพ เพื่อช่วยให้ผู้เช่าทราบสิ่งที่คาดหวัง ข้อมูลที่ครบถ้วนช่วยสร้างความน่าเชื่อถือและเพิ่มโอกาสในการจอง',
      },
      3: {
        title: 'กำหนดบริการและราคา',
        description:
          'คุณจะถูกขอให้ตั้งราคาสำหรับบริการรถเช่าเหมาวันและรับส่งจุดหมาย การตั้งราคาที่เหมาะสมช่วยดึงดูดลูกค้าและเพิ่มรายได้ของคุณ',
      },
      4: {
        title: 'ระบุข้อมูลบริการสำคัญ',
        description:
          'คุณจะถูกขอให้ระบุรายละเอียดสำคัญของบริการ เช่น จุดเด่นและนโยบายที่ผู้เช่าควรทราบ ข้อมูลที่ชัดเจนและถูกต้องช่วยให้ผู้เช่าเข้าใจสิ่งที่คาดหวัง จองด้วยความมั่นใจ และประสบการณ์การเดินทางที่ราบรื่น',
      },
      5: {
        title: 'อัปโหลดเอกสาร',
        description:
          'คุณจะถูกขอให้อัปโหลดเอกสารที่จำเป็น เช่น บัตรประชาชน สมุดบัญชีธนาคาร และเอกสารรถยนต์แต่ละคัน เพื่อยืนยันตัวตนและเริ่มรับการจองได้อย่างรวดเร็ว',
      },
    } as Record<number, { title: string; description: string }>,
  },
  step1: {
    title: 'เพิ่มสถานที่รถของคุณ',
    searchPlaceholder: 'ค้นหาชื่อสถานที่หรือที่อยู่',
    loadingMap: 'กำลังโหลดแผนที่...',
    placeName: 'ชื่อสถานที่',
    unknownPlace: 'ไม่ทราบชื่อสถานที่',
    tapMapHint: 'แตะบนแผนที่หรือค้นหาเพื่อเลือกสถานที่',
    errLocation: 'กรุณาเลือกสถานที่บนแผนที่',
    errName: 'กรุณาระบุชื่อสถานที่',
  },
  step2: {
    title: 'เพิ่มข้อมูลรถ',
    errNoCar: 'กรุณาเพิ่มรถอย่างน้อย 1 ประเภท',
    maxPassengers: (n: number) => `สูงสุด ${n}`,
    largeLuggage: (n: number) => `${n} ใหญ่,…`,
    addCarType: '+ เพิ่มประเภทรถ',
  },
  addCar: {
    title: 'เพิ่มประเภทรถ',
    brand: 'ยี่ห้อรถ',
    selectBrand: 'เลือกยี่ห้อรถ',
    model: 'รุ่น',
    selectModel: 'เลือกรุ่นรถ',
    selectSubModel: 'เลือกรุ่นย่อย',
    selectBrandFirst: 'เลือกยี่ห้อก่อน',
    selectModelFirst: 'เลือกรุ่นก่อน',
    carTypeAutoHint: 'ระบบเลือกประเภทรถให้อัตโนมัติจากรุ่นที่เลือก แตะเพื่อเปลี่ยนได้',
    carTypeManualHint: 'ไม่สามารถระบุประเภทรถจากรุ่นนี้ได้ กรุณาเลือกเอง',
    searchBrand: 'ค้นหายี่ห้อรถ...',
    searchModel: 'ค้นหารุ่นรถ...',
    noBrandData: 'ไม่มีข้อมูลยี่ห้อรถ',
    noBrandFound: 'ไม่พบยี่ห้อรถที่ค้นหา',
    noModelData: 'ไม่มีข้อมูลรุ่นรถ',
    noModelFound: 'ไม่พบรุ่นรถที่ค้นหา',
    errCarType: 'กรุณาเลือกประเภทรถ',
    errBrand: 'กรุณาเลือกยี่ห้อรถ',
    errModel: 'กรุณาเลือกรุ่นรถ',
    uploadFailed: 'อัปโหลดรูปภาพไม่สำเร็จ',
    infoNote:
      'หากคุณมีรถหลายคันในประเภทเดียวกันแต่ต่างยี่ห้อหรือรุ่น ระบุตัวอย่างหนึ่งคัน ผู้เช่าจะเห็นประเภทรถพร้อมรุ่นตัวแทน เช่น "SUV — Honda CR-V และรุ่นที่คล้ายกัน"',
    quantity: 'จำนวน',
    quantitySub: 'จำนวนรถของประเภทที่เลือก',
    maxPassengers: 'ผู้โดยสารสูงสุด',
    maxStandardLuggage: 'กระเป๋าขนาดมาตรฐานสูงสุด',
    maxSmallLuggage: 'กระเป๋าขนาดเล็กสูงสุด',
    luggageStandardSize: '59ซม. × 41ซม. × 24ซม.',
    luggageSmallSize: '49ซม. × 34ซม. × 32ซม.',
    carImages: 'รูปภาพรถ',
    imageSlots: {
      trunkSpace: 'พื้นที่เก็บสัมภาระ',
      frontView: 'ด้านหน้า',
      sideView: 'ด้านข้าง',
      backView: 'ด้านหลัง',
    } as Record<string, string>,
  },
  step3: {
    title: 'บริการและราคา',
    selectServiceDesc: 'เลือกประเภทบริการที่คุณต้องการให้บริการ (เลือกได้มากกว่า 1 ประเภท)',
    errNoService: 'กรุณาเลือกประเภทบริการอย่างน้อย 1 ประเภท',
    roundTripTitle: 'รถเช่าเหมาวัน (Round Trip)',
    roundTripDesc: 'บริการเช่าเหมาวัน 4, 8, 10 หรือ 12 ชั่วโมง สำหรับการเดินทางทัวร์หรือธุรกิจ',
    oneWayTitle: 'รับส่งจุดหมาย (One Way)',
    oneWayDesc: 'บริการรับ-ส่ง ระหว่างจุดหมายที่กำหนด เช่น สนามบิน โรงแรม หรือเส้นทางยอดนิยม',
  },
  roundTrip: {
    title: 'รถเช่าเหมาวัน',
    desc: 'เราตั้งราคาแนะนำให้แต่ละประเภทรถแล้ว คุณสามารถแก้ไขราคาได้ตามต้องการ',
    serviceHourPerDay: 'จำนวนชั่วโมงบริการต่อวัน',
    fullDayPrice: 'ราคาเหมาวัน',
    overnightFee: 'ค่าค้างคืน',
    perNight: 'THB/คืน',
    suggestedPrice: (price: string) => `ราคาแนะนำ : THB ${price}`,
    manageCarTypes: 'จัดการประเภทรถ',
    noCarTypes: 'ยังไม่มีประเภทรถ กรุณาเพิ่มรถก่อนตั้งราคา',
    errPrice: (carType: string) => `กรุณากรอกราคาเหมาวัน (${carType})`,
  },
  oneWay: {
    title: 'รับส่งจุดหมาย',
    popularTitle: 'เลือกเส้นทางยอดนิยมของ HAUP',
    popularDesc: 'เลือกจากเส้นทางยอดนิยมของ HAUP เพื่อตั้งค่าอย่างรวดเร็วและเริ่มให้บริการได้ทันที',
    allPopularAdded: 'คุณเพิ่มเส้นทางยอดนิยมทั้งหมดแล้ว',
    addCustomRoute: '+ เพิ่มเส้นทางกำหนดเอง',
    nextWithCount: (n: number) => `ถัดไป${n > 0 ? ` (${n})` : ''}`,
    selectStart: 'เลือกจุดเริ่มต้น',
    selectDest: 'เลือกจุดหมายปลายทาง',
    searchLocation: 'ค้นหาสถานที่',
    dragMapHint: 'เลื่อนแผนที่เพื่อเลือกจุดนัดพบ',
    locationLabel: 'สถานที่ :',
    customTitle: 'สร้างเส้นทางกำหนดเอง',
    customDesc: 'สร้างเส้นทางของคุณเองและกำหนดราคาที่เหมาะสมกับบริการของคุณ',
    origin: 'จุดรับ',
    selectOrigin: 'เลือกจุดรับ',
    addMoreOrigin: '+ เพิ่มจุดรับ',
    destination: 'จุดส่ง',
    selectDestination: 'เลือกจุดส่ง',
    addMoreDestination: '+ เพิ่มจุดส่ง',
    setPricing: 'ตั้งราคา',
    pricingTitle: 'ตั้งราคา',
    pricingDesc: 'กรอกราคาสำหรับแต่ละเส้นทาง (บาท/เที่ยว)',
    price: 'ราคา',
    select: 'เลือก',
    addCarType: '+ เพิ่มประเภทรถ',
    deleteRouteTitle: 'ลบเส้นทาง?',
    deleteRouteDesc: 'คุณต้องการลบเส้นทางนี้ใช่หรือไม่? การดำเนินการนี้ไม่สามารถย้อนกลับได้',
    noRoutes: 'ยังไม่มีเส้นทาง',
    noRoutesHint: 'กดปุ่มด้านล่างเพื่อเพิ่มเส้นทาง',
    addRoute: '+ เพิ่มเส้นทาง',
    errSelectRoute: 'กรุณาเลือกเส้นทางอย่างน้อย 1 เส้นทาง',
    errOrigin: 'กรุณาเลือกจุดรับ',
    errDestination: 'กรุณาเลือกจุดส่ง',
    errPricing: (origin: string) => `กรุณากรอกราคาอย่างน้อย 1 ประเภทรถ (${origin})`,
    errNoRoute: 'กรุณาเพิ่มเส้นทางอย่างน้อย 1 เส้นทาง',
  },
  step4: {
    serviceInfoTitle: 'ให้ข้อมูลบริการ',
    highlightsTitle: 'จุดเด่นของบริการ',
    highlightsDesc: 'ระบุจุดเด่นสำคัญของบริการ ทีละรายการ',
    highlightPlaceholder: 'เช่น คนขับมืออาชีพ ตรงเวลา ปลอดภัย...',
    addHighlight: '+ เพิ่มจุดเด่น',
    descriptionTitle: 'คำอธิบายบริการ',
    descriptionPlaceholder: 'อธิบายบริการของคุณ...',
    generating: 'กำลังสร้าง...',
    generateWithAi: 'สร้างด้วย AI',
    undo: '↩ ยกเลิก',
    errHighlight: 'กรุณากรอกจุดเด่นของบริการอย่างน้อย 1 รายการ',
    policiesTitle: 'กำหนดนโยบายบริการ',
    instantBooking: 'ยืนยันการจองทันที',
    freeWaitingTime: 'เวลารอฟรี',
    freeWaitingTimeDesc: 'กำหนดระยะเวลาที่คุณจะรอผู้เช่าโดยไม่คิดค่าใช้จ่ายเพิ่มเติม',
    overtimeFee: 'ค่าธรรมเนียมล่วงเวลา',
    overtimeFeeDesc: 'กำหนดค่าธรรมเนียมต่อชั่วโมงที่เกินจากเวลาที่จองไว้',
    babySeatFee: 'ค่าเบาะนั่งเด็กเพิ่มเติม',
    babySeatFeeDesc: 'ระบุราคาสำหรับเบาะนั่งเด็กแต่ละที่นั่งที่ผู้เช่าร้องขอ',
    cancellationPolicy: 'นโยบายการยกเลิก',
    cancellationPolicyDesc: 'เลือกระยะเวลาที่ผู้เช่าสามารถยกเลิกได้โดยไม่เสียค่าใช้จ่าย',
    advancedBookingTime: 'เวลาจองล่วงหน้า',
    advancedBookingTimeDesc: 'กำหนดระยะเวลาที่ต้องการให้ผู้เช่าจองล่วงหน้า',
    includedTitle: 'สิ่งที่รวมอยู่ในบริการ',
    includedDesc: 'ระบุรายละเอียดสิ่งที่รวมอยู่ในบริการของคุณ',
    includedPlaceholder: 'เช่น ค่าธรรมเนียมการใช้รถ',
    notIncludedTitle: 'สิ่งที่ไม่รวมในบริการ',
    notIncludedDesc: 'ระบุรายละเอียดสิ่งที่ไม่รวมอยู่ในบริการของคุณ',
    notIncludedPlaceholder: 'เช่น ค่าใช้จ่ายที่ไม่เกี่ยวข้องกับการเดินทาง',
    addItem: '+ เพิ่มรายการ',
    errOvertimeFee: 'กรุณากรอกค่าธรรมเนียมล่วงเวลา',
    publishing: 'กำลังลงประกาศรถของคุณ...',
    completeTitle: 'คุณทำขั้นตอนหลักครบแล้ว!',
    completeDesc:
      'คุณทำขั้นตอนที่จำเป็นทั้งหมดเสร็จแล้ว รถของคุณลงประกาศบนแพลตฟอร์มและพร้อมรับการจองแล้ว',
    completedSteps: [
      'เพิ่มสถานที่รถของคุณ',
      'บอกเล่าเกี่ยวกับรถของคุณ',
      'กำหนดบริการและราคา',
      'ระบุจุดเด่นของบริการ',
    ],
    optionalTitle: 'ทำขั้นตอนเหล่านี้เมื่อใดก็ได้',
    optionalDesc:
      'คุณสามารถข้ามไปก่อนได้ แต่การทำให้ครบจะช่วยเพิ่มความน่าเชื่อถือและการมองเห็นของประกาศ',
    uploadDocsStep: 'อัปโหลดเอกสาร',
    uploadDocsStepDesc:
      'อัปโหลดเอกสารที่จำเป็นเพื่อยืนยันรถของคุณ เพื่อสร้างความน่าเชื่อถือและให้กระบวนการเช่ารถเป็นไปอย่างราบรื่น',
    continue: 'ต่อไป',
    // Option values are stored in English; these are the display labels.
    optionLabels: {
      '30 minutes': '30 นาที',
      '1 hour': '1 ชั่วโมง',
      '1.5 hours': '1.5 ชั่วโมง',
      '2 hours': '2 ชั่วโมง',
      '3 hours': '3 ชั่วโมง',
      'Same day': 'วันเดียวกัน',
      '24 hours before the trip': '24 ชั่วโมงก่อนเดินทาง',
      '48 hours before the trip': '48 ชั่วโมงก่อนเดินทาง',
      '72 hours before the trip': '72 ชั่วโมงก่อนเดินทาง',
      '7 days before the trip': '7 วันก่อนเดินทาง',
      '1 day': '1 วัน',
      '2 days': '2 วัน',
      '3 days': '3 วัน',
      '7 days': '7 วัน',
    } as Record<string, string>,
  },
  step5: {
    title: 'อัปโหลดเอกสาร',
    carLabel: (carType: string, i: number) => `${carType || 'รถ'} - คันที่ ${i}`,
    uploadSuccess: 'อัปโหลดสำเร็จ',
    uploadFailed: 'อัปโหลดไม่สำเร็จ',
    processing: 'กำลังดำเนินการ...',
    pleaseWait: 'กรุณารอสักครู่',
    licensePlate: 'ทะเบียนรถ',
    platePrefix: 'หมวดหมู่',
    plateNumber: 'หมายเลข',
    province: 'จังหวัดที่จดทะเบียน',
    provincePlaceholder: 'ระบุจังหวัด',
    vin: 'หมายเลขตัวถัง',
    vinPlaceholder: 'ระบุหมายเลขตัวถัง',
    taxExpiry: 'วันหมดอายุภาษีรถยนต์',
    isCompanyRegistered: 'รถของคุณจดทะเบียนในนามบริษัทใช่หรือไม่?',
    isDirector: 'คุณเป็นกรรมการของบริษัทนั้นใช่หรือไม่?',
    companyCertificate: 'หนังสือรับรองบริษัท',
    registrationBook: 'เล่มทะเบียนรถ',
    taxLabel: 'ป้ายภาษี',
    skipAndSave: 'ข้ามและบันทึก',
    idCard: 'บัตรประชาชน',
    bankBook: 'หน้าสมุดบัญชีธนาคาร',
    bankHolderSame: 'ชื่อบัญชีรับเงินเป็นชื่อเดียวกับเจ้าของรถหรือผู้ให้บริการใช่หรือไม่?',
    consentLetter: 'หนังสือยินยอมให้โอนเงินเข้าบัญชีบุคคลอื่น',
    perCarDocs: 'อัปโหลดเอกสารของรถแต่ละคัน',
    noCars: 'คุณยังไม่ได้เพิ่มข้อมูลรถ',
    backToAddCar: 'กลับไปเพิ่มรถ',
    submit: 'ส่ง',
  },
  listing: {
    tab: 'รถพร้อมคนขับ',
    emptyTitle: 'คุณยังไม่ได้ลงรายการรถพร้อมคนขับ!',
    emptyDesc: 'ลงรายการรถพร้อมคนขับและปลดล็อกโอกาสสร้างรายได้ใหม่วันนี้',
    optionTitle: 'รถพร้อมคนขับ',
    optionDesc: 'เสนอบริการแบบเที่ยวเดียว รายชั่วโมง หรือรายวันพร้อมคนขับ',
    company: {
      title: 'กรุณาระบุข้อมูลบริษัทของคุณ',
      name: 'ชื่อบริษัท',
      namePlaceholder: 'กรอกชื่อบริษัท',
      vatId: 'เลขประจำตัวผู้เสียภาษี (VAT ID)',
      vatIdPlaceholder: 'กรอกเลขประจำตัวผู้เสียภาษี',
      logo: 'โลโก้บริษัท',
      next: 'ถัดไป →',
    },
    intro: {
      title: 'แชร์รถของคุณใน 4 ขั้นตอนง่ายๆ เพื่อลงทะเบียนบนแพลตฟอร์ม',
      steps: [
        {
          title: '1. เพิ่มสถานที่บริการ',
          desc: 'ระบุให้ผู้เช่าทราบว่ารถของคุณอยู่ที่ไหน เพื่อเพิ่มการมองเห็นและทำให้การจองสะดวกขึ้น',
        },
        {
          title: '2. บอกเล่าเกี่ยวกับรถของคุณ',
          desc: 'เพิ่มรายละเอียด เช่น ยี่ห้อ รุ่น ประเภท และรูปภาพ เพื่อให้ผู้เช่าทราบสิ่งที่คาดหวัง',
        },
        {
          title: '3. กำหนดบริการและราคา',
          desc: 'ระบุราคาสำหรับแต่ละประเภทบริการ เพื่อให้ผู้เช่าทราบอัตราค่าบริการของคุณ',
        },
        {
          title: '4. เน้นข้อมูลบริการสำคัญ',
          desc: 'ระบุรายละเอียดสำคัญเกี่ยวกับบริการและนโยบายของคุณ เพื่อช่วยให้ผู้เช่าเข้าใจได้ง่าย',
        },
      ],
      skippable: 'ข้ามได้ก่อน',
      extraTitle: 'ขั้นตอนเพิ่มเติมเพื่อเริ่มสร้างรายได้',
      uploadDocs: 'อัปโหลดเอกสาร',
      start: 'เริ่มต้น →',
    },
    item: {
      published: 'เผยแพร่แล้ว',
      completed: 'เสร็จสิ้น',
      incomplete: 'ยังไม่เสร็จสิ้น',
      fallbackName: 'รถพร้อมคนขับ',
      lastEdited: (date: string) => `แก้ไขล่าสุดเมื่อ ${date}`,
      viewCars: 'ดูรถ',
      carsInBranch: 'รถที่ลงทะเบียนในสถานีนี้',
      similarModels: 'หรือรุ่นที่คล้ายกัน',
      continue: 'ดำเนินการต่อ',
    },
  },
}

export type CwdStrings = typeof TH

const EN: CwdStrings = {
  common: {
    saveAndExit: 'Save & exit',
    chatWithUs: 'Chat with us',
    back: '← Back',
    next: 'Next',
    confirm: 'Confirm',
    save: 'Save',
    saving: 'Saving...',
    loading: 'Loading...',
    uploading: 'Uploading...',
    uploadOrTakePhoto: 'Upload or take a photo',
    edit: 'Edit',
    delete: 'Delete',
    cancel: 'Cancel',
    yes: 'Yes',
    no: 'No',
    carType: 'Car type',
    selectCarType: 'Select car type',
    stepOf: (current: number, total: number) => `Step ${current} of ${total}`,
    charCount: (count: number, max: number) => `${count}/${max} characters`,
    hours: (n: number) => `${n} ${n === 1 ? 'hour' : 'hours'}`,
    netRevenueTitle: 'Net Revenue',
    netRevenueDesc:
      'Net Revenue is the final amount of income that you, as the car owner, will receive. The only deduction applied is the 3% withholding tax, with no other fees or charges.',
    netRevenueNote:
      'The price you set here is your net revenue after service fees, which may differ from the price renters see in the HAUP app.',
    deleteItemTitle: 'Delete this item?',
    deleteItemDesc: 'Are you sure you want to delete this item? This action cannot be undone.',
    successTitle: 'Success! Your car is now listed on the platform',
    connectLineTitle: 'Connect with us on LINE',
    connectLineDesc:
      'Before moving to the next step, please connect with us on LINE. Our team will guide you and follow up on your request directly.',
    remainingSteps: 'Remaining steps to complete',
    applicationSubmitted: 'Application submitted',
    carListed: 'Your car is listed on the platform',
    uploadRequiredDocs: 'Upload required documents',
    uploadRequiredDocsDesc: 'Complete your documents before accepting incoming bookings',
    downloadApp: 'Download the app',
    downloadAppDesc:
      'You need the app to manage your listings, receive requests and track your earnings',
    notDone: 'Not done',
    manageYourCars: 'Manage your cars',
    skipAndSubmit: 'Skip & submit',
    submitting: 'Submitting...',
  },
  page: {
    step: (n: number) => `Step ${n}`,
    loadingDraft: 'Loading your data...',
    tutorials: {
      1: {
        title: 'Add your car location',
        description:
          "You'll be asked where your service operates, such as airports, hotels or popular destinations. A clear and accurate location helps renters book with confidence and ensures a smooth, on-time service.",
      },
      2: {
        title: 'Tell us about your cars',
        description:
          "You'll be asked to add car details such as brand, model, type and photos so renters know what to expect. Complete information builds trust and increases your chances of getting booked.",
      },
      3: {
        title: 'Set services and pricing',
        description:
          "You'll be asked to set prices for full-day rental and point-to-point transfer services. The right pricing attracts customers and increases your earnings.",
      },
      4: {
        title: 'Add key service information',
        description:
          "You'll be asked to add key service details such as highlights and policies renters should know. Clear and accurate information helps renters know what to expect, book with confidence and enjoy a smooth trip.",
      },
      5: {
        title: 'Upload documents',
        description:
          "You'll be asked to upload required documents such as your ID card, bank book and documents for each car, to verify your identity and start receiving bookings quickly.",
      },
    },
  },
  step1: {
    title: 'Add your car location',
    searchPlaceholder: 'Search place name or address',
    loadingMap: 'Loading map...',
    placeName: 'Place name',
    unknownPlace: 'Unknown place',
    tapMapHint: 'Tap on the map or search to select a location',
    errLocation: 'Please select a location on the map',
    errName: 'Please enter a place name',
  },
  step2: {
    title: 'Add car details',
    errNoCar: 'Please add at least 1 car type',
    maxPassengers: (n: number) => `Max ${n}`,
    largeLuggage: (n: number) => `${n} large,…`,
    addCarType: '+ Add car type',
  },
  addCar: {
    title: 'Add car type',
    brand: 'Car brand',
    selectBrand: 'Select car brand',
    model: 'Model',
    selectModel: 'Select car model',
    selectSubModel: 'Select sub-model',
    selectBrandFirst: 'Select a brand first',
    selectModelFirst: 'Select a model first',
    carTypeAutoHint: 'Car type is set automatically from the selected model. Tap to change it.',
    carTypeManualHint: "We couldn't detect the car type for this model. Please select one.",
    searchBrand: 'Search car brand...',
    searchModel: 'Search car model...',
    noBrandData: 'No car brands available',
    noBrandFound: 'No matching car brand',
    noModelData: 'No car models available',
    noModelFound: 'No matching car model',
    errCarType: 'Please select a car type',
    errBrand: 'Please select a car brand',
    errModel: 'Please select a car model',
    uploadFailed: 'Failed to upload image',
    infoNote:
      'If you have several cars of the same type but different brands or models, enter one example. Renters will see the car type with a representative model, e.g. "SUV — Honda CR-V or similar".',
    quantity: 'Quantity',
    quantitySub: 'Number of cars of this type',
    maxPassengers: 'Max passengers',
    maxStandardLuggage: 'Max standard luggage',
    maxSmallLuggage: 'Max small luggage',
    luggageStandardSize: '59cm × 41cm × 24cm',
    luggageSmallSize: '49cm × 34cm × 32cm',
    carImages: 'Car images',
    imageSlots: {
      trunkSpace: 'Trunk space',
      frontView: 'Front view',
      sideView: 'Side view',
      backView: 'Back view',
    },
  },
  step3: {
    title: 'Services and pricing',
    selectServiceDesc: 'Select the services you want to offer (you can select more than one)',
    errNoService: 'Please select at least 1 service',
    roundTripTitle: 'Full-day rental (Round Trip)',
    roundTripDesc: 'Full-day hire for 4, 8, 10 or 12 hours, for tours or business trips',
    oneWayTitle: 'Point-to-point transfer (One Way)',
    oneWayDesc:
      'Pick-up and drop-off between set points, such as airports, hotels or popular routes',
  },
  roundTrip: {
    title: 'Full-day rental',
    desc: "We've set a suggested price for each car type. You can edit the prices as you like.",
    serviceHourPerDay: 'Service hour per day',
    fullDayPrice: 'Full day price',
    overnightFee: 'Overnight fee',
    perNight: 'THB/night',
    suggestedPrice: (price: string) => `Suggested price : THB ${price}`,
    manageCarTypes: 'Manage car types',
    noCarTypes: 'No car types yet. Please add your cars before setting prices.',
    errPrice: (carType: string) => `Please fill in the full day price (${carType})`,
  },
  oneWay: {
    title: 'Point-to-point transfer',
    popularTitle: "Select HAUP's popular routes",
    popularDesc: "Choose from HAUP's popular routes to set up quickly and start serving right away",
    allPopularAdded: "You've added all popular routes",
    addCustomRoute: '+ Add custom route',
    nextWithCount: (n: number) => `Next${n > 0 ? ` (${n})` : ''}`,
    selectStart: 'Select starting point',
    selectDest: 'Select destination point',
    searchLocation: 'Search location',
    dragMapHint: 'Drag the map to select meeting point',
    locationLabel: 'Location :',
    customTitle: 'Create custom route',
    customDesc: 'Create your own routes and set prices that suit your service',
    origin: 'Origin',
    selectOrigin: 'Select origin',
    addMoreOrigin: '+ Add more origin',
    destination: 'Destination',
    selectDestination: 'Select destination',
    addMoreDestination: '+ Add more destination',
    setPricing: 'Set pricing',
    pricingTitle: 'Set pricing',
    pricingDesc: 'Enter the price for each route (THB/trip)',
    price: 'Price',
    select: 'Select',
    addCarType: '+ Add car type',
    deleteRouteTitle: 'Delete route?',
    deleteRouteDesc: 'Are you sure you want to delete this route? This action cannot be undone.',
    noRoutes: 'No routes yet',
    noRoutesHint: 'Tap the button below to add a route',
    addRoute: '+ Add route',
    errSelectRoute: 'Please select at least 1 route',
    errOrigin: 'Please select an origin',
    errDestination: 'Please select a destination',
    errPricing: (origin: string) => `Please enter a price for at least 1 car type (${origin})`,
    errNoRoute: 'Please add at least 1 route',
  },
  step4: {
    serviceInfoTitle: 'Service information',
    highlightsTitle: 'Service highlights',
    highlightsDesc: 'List the key highlights of your service, one per item',
    highlightPlaceholder: 'e.g. Professional driver, punctual, safe...',
    addHighlight: '+ Add highlight',
    descriptionTitle: 'Service description',
    descriptionPlaceholder: 'Describe your service...',
    generating: 'Generating...',
    generateWithAi: 'Generate with AI',
    undo: '↩ Undo',
    errHighlight: 'Please enter at least 1 service highlight',
    policiesTitle: 'Service policies',
    instantBooking: 'Instant booking',
    freeWaitingTime: 'Free waiting time',
    freeWaitingTimeDesc: 'How long you will wait for the renter at no extra charge',
    overtimeFee: 'Overtime fee',
    overtimeFeeDesc: 'Fee per hour beyond the booked time',
    babySeatFee: 'Extra baby seat fee',
    babySeatFeeDesc: 'Price for each baby seat requested by the renter',
    cancellationPolicy: 'Cancellation policy',
    cancellationPolicyDesc: 'How long before the trip renters can cancel free of charge',
    advancedBookingTime: 'Advance booking time',
    advancedBookingTimeDesc: 'How far in advance renters need to book',
    includedTitle: "What's included",
    includedDesc: 'List what is included in your service',
    includedPlaceholder: 'e.g. Car usage fee',
    notIncludedTitle: "What's not included",
    notIncludedDesc: 'List what is not included in your service',
    notIncludedPlaceholder: 'e.g. Expenses unrelated to the trip',
    addItem: '+ Add item',
    errOvertimeFee: 'Please enter the overtime fee',
    publishing: 'Listing your car...',
    completeTitle: "You've completed the main steps!",
    completeDesc:
      'All required steps are done. Your car is listed on the platform and ready for bookings.',
    completedSteps: [
      'Add your car location',
      'Tell us about your cars',
      'Set services and pricing',
      'Add service highlights',
    ],
    optionalTitle: 'Complete these steps any time',
    optionalDesc:
      'You can skip for now, but completing them increases the trust and visibility of your listing.',
    uploadDocsStep: 'Upload documents',
    uploadDocsStepDesc:
      'Upload the required documents to verify your car, build trust and keep the rental process smooth.',
    continue: 'Continue',
    optionLabels: {
      '30 minutes': '30 minutes',
      '1 hour': '1 hour',
      '1.5 hours': '1.5 hours',
      '2 hours': '2 hours',
      '3 hours': '3 hours',
      'Same day': 'Same day',
      '24 hours before the trip': '24 hours before the trip',
      '48 hours before the trip': '48 hours before the trip',
      '72 hours before the trip': '72 hours before the trip',
      '7 days before the trip': '7 days before the trip',
      '1 day': '1 day',
      '2 days': '2 days',
      '3 days': '3 days',
      '7 days': '7 days',
    },
  },
  step5: {
    title: 'Upload documents',
    carLabel: (carType: string, i: number) => `${carType || 'Car'} - #${i}`,
    uploadSuccess: 'Uploaded successfully',
    uploadFailed: 'Upload failed',
    processing: 'Processing...',
    pleaseWait: 'Please wait a moment',
    licensePlate: 'License plate',
    platePrefix: 'Prefix',
    plateNumber: 'Number',
    province: 'Registration province',
    provincePlaceholder: 'Enter province',
    vin: 'VIN (chassis number)',
    vinPlaceholder: 'Enter chassis number',
    taxExpiry: 'Vehicle tax expiration date',
    isCompanyRegistered: 'Is your car registered under a company?',
    isDirector: 'Are you a director of that company?',
    companyCertificate: 'Company certificate',
    registrationBook: 'Vehicle registration book',
    taxLabel: 'Tax label',
    skipAndSave: 'Skip & save',
    idCard: 'ID card',
    bankBook: 'Bank book page',
    bankHolderSame: 'Is the bank account name the same as the car owner or service provider?',
    consentLetter: 'Consent letter for payment to another account',
    perCarDocs: 'Upload documents for each car',
    noCars: "You haven't added any cars yet",
    backToAddCar: 'Go back to add cars',
    submit: 'Submit',
  },
  listing: {
    tab: 'Car with driver',
    emptyTitle: "You haven't listed a car with driver yet!",
    emptyDesc: 'List your car with driver and unlock new earning opportunities today',
    optionTitle: 'Car with driver',
    optionDesc: 'Offer one-way, hourly or daily service with a driver',
    company: {
      title: 'Please enter your company information',
      name: 'Company name',
      namePlaceholder: 'Enter company name',
      vatId: 'Tax ID (VAT ID)',
      vatIdPlaceholder: 'Enter tax ID',
      logo: 'Company logo',
      next: 'Next →',
    },
    intro: {
      title: 'Share your car in 4 easy steps to register on the platform',
      steps: [
        {
          title: '1. Add service location',
          desc: 'Let renters know where your car is, to increase visibility and make booking easier',
        },
        {
          title: '2. Tell us about your cars',
          desc: 'Add details such as brand, model, type and photos so renters know what to expect',
        },
        {
          title: '3. Set services and pricing',
          desc: 'Set prices for each service type so renters know your rates',
        },
        {
          title: '4. Highlight key service info',
          desc: 'Add key details about your service and policies to help renters understand easily',
        },
      ],
      skippable: 'Skippable',
      extraTitle: 'Additional steps to start earning',
      uploadDocs: 'Upload documents',
      start: 'Get started →',
    },
    item: {
      published: 'Published',
      completed: 'Completed',
      incomplete: 'Incomplete',
      fallbackName: 'Car with driver',
      lastEdited: (date: string) => `Last edited ${date}`,
      viewCars: 'View cars',
      carsInBranch: 'Cars registered at this location',
      similarModels: 'or similar',
      continue: 'Continue',
    },
  },
}

export const cwdTranslations: Record<Lang, CwdStrings> = { TH, EN }
